import portugal from '@icons/countriesFlags/portugal.svg';

export default {
  portugal,
};
